import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'appfolio.auth.root',
  params: ['id'],
});

export const oauthRouteRef = createRouteRef({
  id: 'appfolio.auth.oauth',
  params: ['sessionId'],
});
